/* 劉備傳・第 10 章：漢水（219 年）
 * 趙雲的營在南邊（木柵圍起來，北面有營門）；漢水在更南邊。黃忠在北邊被曹軍圍住，曹軍大隊從東北方來。 */
export const CAMP = { x: 3600, y: 3300, hw: 650, hh: 420 };
const T = 30, N = CAMP.y - CAMP.hh, S = CAMP.y + CAMP.hh, Wx = CAMP.x - CAMP.hw, E = CAMP.x + CAMP.hw;
export const GATE = [CAMP.x, N], ZHONG = [5200, 1300], CAO = [7200, 800];
export default {
  id: 'hanshui', name: '漢水', W: 8000, H: 5000, seed: 2191,
  bases: [[CAMP.x, CAMP.y], CAO],
  walls: [[(Wx + GATE[0] - 120) / 2, N, (GATE[0] - 120 - Wx) / 2 + T, T], [(GATE[0] + 120 + E) / 2, N, (E - GATE[0] - 120) / 2 + T, T], [CAMP.x, S, CAMP.hw + T, T], [Wx, CAMP.y, T, CAMP.hh], [E, CAMP.y, T, CAMP.hh]],
  rivers: [{ pts: [[-100, 4500], [4000, 4450], [8100, 4520]], hw: 230, fords: [] }],
  roads: [{ pts: [[CAMP.x, CAMP.y], GATE, [3800, 2300], [4600, 1700], ZHONG, [6200, 1000], CAO], w: 130 }],
  rocks: [[1500, 1500, 420, 200], [2400, 3700, 300, 160], [6200, 2700, 420, 200], [1300, 3300, 300, 160]],
  woods: 0.4,
  sight: 0.8,
  clearings: [[CAMP.x, CAMP.y, 760], [GATE[0], GATE[1] - 500, 600], [ZHONG[0], ZHONG[1], 450], [CAO[0], CAO[1], 500]],
  tents: [{ x: CAMP.x, y: CAMP.y + 60, n: 6, r: 380, chief: true, col: '#3e7b50', flag: '趙' }, { x: CAO[0], y: CAO[1], n: 6, r: 380, col: '#3b5a99', flag: '曹' }],
};
